import React, {Component} from 'react';
import {Switch, Route, withRouter, Redirect} from 'react-router-dom';
import {Helmet} from 'react-helmet';
import CONFIG from './../../SYSTEM/Config.js'

import {Request} from "./../../SYSTEM/Request"

/// REDUX ///
import * as ReduxActions from './../../REDUX/functions';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';

import Header from './../../APP/COMPONENTS/Header';
import LeftNav from './../../APP/COMPONENTS/LeftNav';
import Loader from "../COMPONENTS/Loader";
import {openCommentModal} from "./../../REDUX/functions";

function mapStateToProps(state, myProps) {
    return {
        USER: state.USER
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(ReduxActions, dispatch)
}


class Comments extends Component {
    constructor(props) {
        super(props);
        this.state = {
            USER: this.props.USER,
            LOADED: false,
            PRODUCTS: false,
            DATE_TILL: false,
            DATE_FROM: false,

        }
    }

    componentDidMount = () => {
        this.fetchProductsRates();
    }


    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.USER !== prevProps.USER) {
            this.setState({USER: this.props.USER});
        }
    }

    fetchProductsRates = async () => {
        let SEND_DATA = {};

        if(this.state.DATE_FROM || this.state.DATE_TILL){
            SEND_DATA = {
                action: 'supplierProductsRates',
                supplier_apikey: this.props.USER.supplier_apikey,
                date_from: this.state.DATE_FROM,
                date_till: this.state.DATE_TILL
            };
        }else{
            SEND_DATA = {
                action: 'supplierProductsRates',
                supplier_apikey: this.props.USER.supplier_apikey,
            };
        }

        try {
            let data = await Request(SEND_DATA, CONFIG.API_GATE);
            if (data !== false) {
                this.setState({PRODUCTS: data.products, LOADED: true});
            } else {
                this.setState({LOADED: true});
            }
        } catch (error) {
        }
    }

    renderProducts = () => {
        if (this.state.LOADED) {
            if (this.state.PRODUCTS.length > 0) {
                let PRODUCTS = this.state.PRODUCTS;
                let TBODY = this.renderProductsRows(PRODUCTS);
                let HEADER = this.renderProductsTableHeader();

                return (
                    <div className="table_holder">
                        <table className="products_table" cellPadding="0" cellSpacing="0">
                            {HEADER}
                            {TBODY}
                        </table>
                    </div>
                );
            } else {
                return <div className="table_holder"><h3>Мы не нашли отзывов за данный период в базе</h3></div>;
            }
        } else {
            return <div className="table_holder"><Loader/>
                <div className="loader_content">Собираем статистику по отзывам ...</div>
            </div>
        }
    }

    renderImage = (PRODUCT) => {
        let SRC = PRODUCT.images.thumb;
        if ((typeof SRC !== "undefined") && (SRC !== "")) {
            return (
                <img
                    className="product_image"
                    src={CONFIG.API_C_DOMAIN + SRC}
                />
            );
        }

        return false;
    }

    renderProductsRows = (PRODUCTS) => {
        let ROWS = [];
        for (let i = 0; i < PRODUCTS.length; i++) {
            let PRODUCT = PRODUCTS[i];

            ROWS.push(
                <tr key={i}>
                    <td className="cell-center">{this.renderImage(PRODUCT)}</td>
                    <td><span className="product_title">{PRODUCT.title}</span></td>
                    <td className="left_small">{PRODUCT.rate === null ? 0 : PRODUCT.rate}</td>
                    <td className="rate_holder" onClick={() => this.props.openCommentModal({product: PRODUCT, date_till: this.state.DATE_TILL, date_from: this.state.DATE_FROM})}>
                        <div className="amount_comments" >
                            {PRODUCT.comments_amount} отзывов
                        </div>
                        <div className="read_comment_button" >читать отзывы</div>
                    </td>
                </tr>
            );
        }

        return (
            <tbody>
            {ROWS}
            </tbody>
        );
    }

    renderProductsTableHeader = () => {
        return (
            <thead>
            <tr>
                <th>фото</th>
                <th>наименование</th>
                <th>☆ оценка</th>
                <th className="comments_title_text">отзывы</th>
            </tr>
            </thead>
        );
    }

    renderFiter = () => {
        return (
            <div className="filter_head_comments">
                <h1>Отзывы</h1>
                {this.renderSearchInput()}
            </div>
        );
    }



    appendFilter = async (data, type) => {

        switch (type) {
            case "date_from":
                this.setState({DATE_FROM: data.target.value}, () => this.fetchProductsRates())
                break;
            case "date_till":
                this.setState({DATE_TILL: data.target.value}, () => this.fetchProductsRates())
                break;
        }

    }


    renderSearchInput = () => {
        if (this.state.LOADED) {
            return (
                <div className="filter_inputs_holder">
                    <div className="filter_head_text">Выбрать даты в период с</div>
                    <div className="filter_element">
                        <input
                            type="date"
                            placehodler="выбрать дату"
                            value={this.state.DATE_FROM}
                            onChange={(text) => this.appendFilter(text, 'date_from')}
                        />
                    </div>

                    <div className="filter_head_text">по</div>

                    <div className="filter_element">
                        <input
                            type="date"
                            placehodler="выбрать дату"
                            value={this.state.DATE_TILL}
                            onChange={(text) => this.appendFilter(text, 'date_till')}
                        />
                    </div>
                </div>
            );
        }
    }


    render() {
        if (!this.state.USER) {
            return <Redirect to="/"/>
        }

        return (
            <div className="main_content">
                <Helmet>
                    <title>Отзывы</title>
                </Helmet>
                {this.renderFiter()}
                {this.renderProducts()}
            </div>
        );
    }
}

export default withRouter(connect(
    mapStateToProps, mapDispatchToProps
)(Comments))
